<template>
  <div class="overlay" v-if="active">
    <div class="modal">
      <div class="layout">
        <a
          href="#"
          class="btn navigation-icon close"
          v-on:click.prevent="$emit('update:active', false)"
        ></a>

        <div class="wrapper">
          <h2>{{ content.title }}</h2>
          <div class="bio" v-html="content.bio"></div>

          <div v-if="content.twitter" class="call-to-action">
            <h5>Connect with {{ content.connect }}:</h5>
            <a
              v-bind:href="content.twitter"
              target="_blank"
              class="btn twitter"
            ></a>
          </div>
        </div>

        <a
          href="#"
          class="btn navigation-icon close -bottom d-md-none"
          v-on:click.prevent="$emit('update:active', false)"
        ></a>
      </div>
    </div>

    <div class="backdrop"><!-- backdrop --></div>
  </div>
</template>

<script>
export default {
  name: "overlay",
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    content: {
      type: Object,
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";
@import "../../css/components/modal";

.overlay {
  .layout {
    position: relative;
    background-color: $cc-resmed-grey-15;

    @media (min-width: 768px) {
      background-color: $cc-resmed-white;
      margin: 6rem auto;
      width: 740px;
      max-width: 90vw;
      box-shadow: 0 2rem 3rem 0 rgba(0, 0, 0, 0.75);
    }

    @media (min-height: 800px) {
      margin: 12rem auto;
    }

    .wrapper {
      padding: 5rem 3rem 3rem 3rem;
    }

    h2 {
      position: relative;
      margin-bottom: 1.5rem;

      @extend %eyebrow-left;
    }

    .call-to-action {
      margin-top: 2rem;

      h5 {
        margin-bottom: 0.5rem;
      }

      .twitter {
        display: block;
        width: 1rem;
        height: 1rem;
        padding: 0;
        background-position: center center;
        background-repeat: no-repeat;
        background-size: contain;
        background-image: url(#{$assets}/images/social-media-icon-twitter.svg);
      }
    }
  }

  .close {
    @media (max-width: 767px) {
      top: 1rem;
      right: 1rem;
      transform: scale(0.8);
    }

    &.-bottom {
      top: auto;
      bottom: 1rem;
    }
  }
}
</style>